/**
 * React Query keys for analytics
 */

export const queryKey = {
  getCustomerAdoptionStatus: 'ANALYTICS_GET_CUSTOMER_ADOPTION_STATUS',
  getQuoteConversionByRegion: 'ANALYTICS_GET_QUOTE_CONVERSION_BY_REGION',
  getConversionAnalysis: 'ANALYTICS_GET_CONVERSION_ANALYSIS',
  getCustomerRankingByRevenue: 'ANALYTICS_GET_CUSTOMER_RANKING_BY_REVENUE',
  getProductPerformance: 'ANALYTICS_GET_PRODUCT_PERFORMANCE',
};
